import React, { useRef, useState } from 'react';

import { BasicMenu } from '@/components/common-components/Select/BasicMenu';

import { ChevronToggle } from '../ChevronToggle';
import ShortString from '../ShortString/ShortString';

import './_newSingleSelect.scss';

import RequiredAsterisk from '../RequiredAsterisk/RequiredAsterisk';

export interface OptionsInterface {
  label: string;
  value: string | number;
  isDisabled?: boolean;
  disabledTooltip?: string;
}

interface NewSingleSelectInterface {
  value: string | number;
  onSelect: (value: string | number) => void;
  options: OptionsInterface[];
  placeholder: string;
  height?: number;
  stringLength?: number;
  optionStringLength?: number;
  leftIcon?: React.ReactNode;
  label?: React.ReactNode | string;
  required?: boolean;
  className?: string;
  dropdownStyles?: React.CSSProperties;
  showTick?: boolean;
  fontSize?: string;
  wrapperClassName?: string;
  chevronColor?: string;
  dropdownWidth?: number;
}

const NewSingleSelect: React.FC<NewSingleSelectInterface> = ({
  onSelect,
  value,
  options,
  placeholder,
  height,
  stringLength,
  optionStringLength,
  leftIcon,
  label,
  required,
  className,
  dropdownStyles = {},
  showTick = true,
  fontSize = '16px',
  wrapperClassName = '',
  chevronColor = 'var(--icon-subdued)',
  dropdownWidth,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const divElementRef = useRef<HTMLDivElement | null>(null);

  const getSelectedValue = () => {
    const result = options.find((option) => option.value === value)?.label;
    return result || '';
  };
  return (
    <div className={wrapperClassName}>
      {label && (
        <label className="text-sm text-subdued mb-1 flex flex-start gap-1">
          {label}
          {required && <RequiredAsterisk />}
        </label>
      )}
      <div
        ref={divElementRef}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className={`new-single-select-container ${anchorEl ? 'select-active' : ''} ${className}`}>
        <span className="flex flex-start gap-2">
          {leftIcon && <span className="flex items-center">{leftIcon}</span>}
          {value ? (
            <ShortString
              name={getSelectedValue()}
              stringLength={stringLength || 25}
              placement="bottom"
              style={{ fontSize }}
            />
          ) : (
            <span className="text-base text-disabled">{placeholder}</span>
          )}
        </span>
        <ChevronToggle toggle={Boolean(anchorEl)} color={chevronColor} />
      </div>
      <BasicMenu
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        selectedValue={value}
        onSelect={(v) => {
          onSelect(v);
          setAnchorEl(null);
        }}
        menuItems={options}
        width={dropdownWidth || divElementRef?.current?.clientWidth || 320}
        height={height}
        optionStringLength={optionStringLength}
        dropdownStyles={dropdownStyles}
        showTick={showTick}
        fontSize={fontSize}
      />
    </div>
  );
};

export default NewSingleSelect;
